import qs from 'qs';
import { api } from 'src/api/api';

import {
  TimelineCalendarDay,
  TimelineCalendarResponse,
  TimelineCalendarWindow,
} from '../calendarTypes';
import { isCivilDate } from '../timelineCalendarDates';

import { FetchTimelineDataParams } from './index';

export type FetchTimelineCalendarDaysParams = TimelineCalendarWindow &
  Omit<
    FetchTimelineDataParams,
    'page' | 'pageSize' | 'sort' | 'dateStart' | 'dateEnd'
  >;

const toCalendarQueryParams = ({
  signal: _signal,
  ...params
}: FetchTimelineCalendarDaysParams) => {
  const queryParams: Record<string, unknown> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length === 0) return;
    if (typeof value === 'string' && !value.trim()) return;
    if (value === undefined || value === false) return;

    queryParams[key] = typeof value === 'string' ? value.trim() : value;
  });

  return queryParams;
};

const isCalendarDay = (day: unknown): day is TimelineCalendarDay =>
  typeof day === 'object' &&
  day !== null &&
  isCivilDate((day as TimelineCalendarDay).date);

export const fetchTimelineCalendarDays = async (
  params: FetchTimelineCalendarDaysParams,
) => {
  const query = qs.stringify(toCalendarQueryParams(params), {
    encodeValuesOnly: true,
  });
  const endpoint = `/meta-linha-do-tempos/calendar?${query}`;
  const { data: response } = params.signal
    ? await api.get<TimelineCalendarResponse>(endpoint, {
        signal: params.signal,
      })
    : await api.get<TimelineCalendarResponse>(endpoint);

  return (Array.isArray(response?.data) ? response.data : []).filter(
    isCalendarDay,
  );
};
